import { connect } from 'react-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { Tree } from '../components/FilterOptions/Tree';
import {
  selectChildNodes,
  selectParentNodes,
  selectRouterPathWithoutCurrentFilter,
} from '../modules/selectors/treeSelectors';
import { FilterOptionsProps } from '../types';

export const mapStateToProps = (state: ReduxApplicationState, ownProps: FilterOptionsProps) => ({
  pathWithoutCurrentFilter: selectRouterPathWithoutCurrentFilter(state, ownProps),
  parentNodes: selectParentNodes(state, ownProps),
  childNodes: selectChildNodes(state, ownProps),
});

export const TreeContainer = connect(mapStateToProps)(Tree);
